module.exports = __webpack_public_path__ + "static/media/spotifylight.765500f3.png";